/**
 * Columns for the change events list.
 *
 * No `sorter` is set on purpose. PaginationTable sorts on the client and only
 * reorders the rows already on screen, which would be wrong for a server-paged
 * list. The screen sends `sort` to the API and re-fetches instead.
 */
const ChangeEventListColumn = [
  {
    title: 'No.',
    dataIndex: 'index',
    width: 70
  },
  {
    // The id people quote when they talk about one group, the same way the
    // site-wide incidents list carries Incident ID.
    title: 'Group ID',
    dataIndex: 'id',
    slot: 'groupId',
    width: 100
  },
  {
    title: 'Website',
    dataIndex: 'site',
    slot: 'site',
    width: 220
  },
  {
    title: 'Category',
    dataIndex: 'categoryLabel',
    // Both headings explain themselves on hover. These two words mean nothing
    // to a person who opens this section for the first time.
    slotTitle: 'categoryTitle',
    width: 220
  },
  {
    title: 'Change Type',
    dataIndex: 'changeTypeLabel',
    slotTitle: 'changeTypeTitle',
    width: 220
  },
  {
    // The worst severity, with the mix of the alerts inside underneath it.
    title: 'Severity',
    dataIndex: 'severity',
    slot: 'severity',
    width: 170
  },
  {
    title: 'Alerts',
    dataIndex: 'alertCount',
    width: 90
  },
  {
    title: 'Pages',
    dataIndex: 'pageCount',
    width: 90
  },
  {
    title: 'First Alert',
    dataIndex: 'firstSeen',
    slot: 'firstSeen',
    width: 130
  },
  {
    title: 'Last Alert',
    dataIndex: 'lastSeen',
    slot: 'lastSeen',
    width: 130
  },
  {
    title: 'Status',
    dataIndex: 'statusLabel',
    slot: 'status',
    width: 100
  },
  {
    title: '',
    dataIndex: '',
    width: 50,
    slot: 'operation'
  }
];

export { ChangeEventListColumn };
